export default "__VITE_ASSET__Wf3D2ale__"